import { Injectable } from '@angular/core';
import {Router} from '@angular/router';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {ServiceConfig} from './service-config';
import {HttpClient} from '@angular/common/http';
@Injectable()
export class FbUserSeedingService {

  private host = ServiceConfig.host;
  private baseUrl = this.host + '/api/fb-user-seeding/';
  private data: any;
  private headers: Headers;
  private options: {};

  constructor(private http: HttpClient,
              private router: Router) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    // console.log(this.data.token);
    this.headers = new Headers({
      'Content-Type': 'application/json'
    });
    this.options = {headers: this.headers};
  }

  public indexAll() {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + 'all?token=' + this.data.token;
    return this.http.get<any>(url);
  }

  public index(typeAccount,projectId,statusAccount, type='all',hasVnptAvt:string|null) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = `${this.baseUrl}?token=${this.data.token}&typeAccount=${typeAccount}&projectId=${projectId}&statusAccount=${statusAccount}`;
    if (type !== 'all'){
      url = `${url}&type=${type}`
    }
    if(hasVnptAvt !== '0') {
      url = `${url}&hasVnptAvt=${hasVnptAvt}`
    }
    return this.http.get<any>(url);
  }

  public updateTypeAccount(ids, type) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + 'updateTypeAccount?token=' + this.data.token;
    return this.http.post<any>(url, { ids, type});
  }


  public getActive() {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = `${this.baseUrl}getActive?token=${this.data.token}`;
    return this.http.get<any>(url);
  }

  public getAllType() {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = `${this.baseUrl}getAllTypeAccount?status=true&token=${this.data.token}`;
    return this.http.get<any>(url);
  }


  public create(body) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + 'create?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public get(username: String) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + username + '?token=' + this.data.token;
    return this.http.get<any>(url);
  }

  public update(userId: String, body) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + userId + '/update?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }


  public updateOrCreate( body) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + '/updateOrCreate?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }



  public copyAccountSeeding(body) {
    let url = this.baseUrl + '/updateMany?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public assigneToAccount(body) {
    let url = this.baseUrl+ 'assigneToAaccount?token='  + this.data.token;
    return this.http.post<any>(url, body);
  }

  public releaseAccount(body) {
    let url = this.baseUrl+ 'releaseAccount?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public deleteAccount(body) {
    let url = this.baseUrl+ 'deleteAccount?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public delete(userId: String) {
    let url = this.baseUrl + userId + '/delete?token=' + this.data.token;
    return this.http.post<any>(url, this.options);
  }

  public changePassword(userId: String, body) {
    let url = this.baseUrl + userId + '/change_password?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getUserByProject(projectId: String) {
    let url = this.baseUrl + projectId + '?token=' + this.data.token;
    return this.http.get<any>(url);
  }

  public addAccount(body) {
    let url = this.baseUrl + 'add-account?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getByVpsHosting(vpsHostingId: String) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + vpsHostingId + '/getByVpsHosting?token=' + this.data.token;
    return this.http.get<any>(url);
  }

  public updateVpsHosting(vpsHostingId: String, body) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + vpsHostingId + '/updateVpsHosting?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public deleteVpsHosting(vpsHostingId: String) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + vpsHostingId + '/deleteVpsHosting?token=' + this.data.token;
    return this.http.post<any>(url,  this.options);
  }

  public getAccoutseedingsByAccounts(body) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl +  '/getAccountSeedingByAccount?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/fb-user-seeding.service.ts